import { MediaObserver } from '@angular/flex-layout';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout/core";
var FuseMatchMediaService = /** @class */ (function () {
    function FuseMatchMediaService(mediaObserver) {
        this.mediaObserver = mediaObserver;
        this.onMediaChange = new BehaviorSubject('');
        this.init();
    }
    FuseMatchMediaService.prototype.init = function () {
        var _this = this;
        this.mediaObserver
            .asObservable()
            .pipe(debounceTime(500), distinctUntilChanged(), map(function (changes) { return changes[0]; }), filter(function (change) { return _this.onMediaChange.value !== change.mqAlias; }))
            .subscribe(function (change) {
            _this.onMediaChange.next(change.mqAlias);
        });
    };
    FuseMatchMediaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseMatchMediaService_Factory() { return new FuseMatchMediaService(i0.ɵɵinject(i1.MediaObserver)); }, token: FuseMatchMediaService, providedIn: "root" });
    return FuseMatchMediaService;
}());
export { FuseMatchMediaService };
